import React, { Fragment, useContext, useEffect, useState } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import DocumentUploadContext from '../../context/DocumentUpload/documentUploadContext';
import InsertDriveFileIcon from '@material-ui/icons/InsertDriveFile';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import NotificationContext from '../../context/Notification/notificationContext';
import Notification from '../../components/notification/Notification';
import AddIcon from '@material-ui/icons/Add';

//import PDFtoIMG from '../../utils/PDFToImage';
const PDFJS = require("pdfjs-dist/webpack");
const { decode } = require("decode-tiff");
const { PNG } = require("pngjs");
const Jimp = require('jimp');
var ConvertTiff = require('tiff-to-png');
const UTIF = require('utif');
let UPNG = require('upng-js');
const fileToArrayBuffer = require('file-to-array-buffer');
//const { Tiff } = require("tiff.js");

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    textAlign: 'center',
    color: theme.palette.text.secondary,
  },
  input: {
    display: 'none',
  },
  viewFile: {
    textTransform: 'none',
    color: '#0054a4',
  },
  displayImage: {
    width: '100%',
  },
  deleteButton: {
    textTransform: 'none',
  },
  dialogFooter: {
    justifyContent: 'center',
  },
}));

const DocumentItems = ({ doc, refNo }) => {
  const documentUploadContext = useContext(DocumentUploadContext); //Use documentUploadContext from context/DocumentUploadContext
  const {
    uploadDocument,
    uploadedDocuments,
    userInfo,
    errors,
    clearErrors,
  } = documentUploadContext;
  const notificationContext = useContext(NotificationContext);
  const classes = useStyles();
  const [uploadedDocument, setUploadedDoc] = useState([]);
  const acceptedImageTypes = ['image/jpeg', 'image/bmp', 'image/gif', 'image/png', 'image/tiff', 'application/pdf'];
  const accImageTypes = ['image/jpeg', 'image/bmp', 'image/gif', 'image/png', 'image/tiff'];
  ////(file);   
  useEffect(() => {
    if (errors != null) {
      notificationContext.setNotification(errors, 'error');
      clearErrors();
      ////(errors);
    } // eslint-disable-next-line
    // eslint-disable-line react-hooks/exhaustive-deps
    // eslint-disable-next-line
  }, [uploadedDocuments, errors]); // eslint-disable-next-line
  ////(userInfo);
  const toBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });

  const readFileData = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (e) => {
        resolve(e.target.result);
      };
      reader.onerror = (err) => {
        reject(err);
      };
      reader.readAsDataURL(file);
    });
  };

  //param: file -> the input file (e.g. event.target.files[0])
  //return: images -> an array of images encoded in base64 
  const PDFtoIMG = async (file) => { //(file, setImage) {

    let images = [];
    const data = await readFileData(file);
    const pdf = await PDFJS.getDocument(data).promise;
    const canvas = document.createElement("canvas");
    for (let i = 0; i < pdf.numPages; i++) {
      const page = await pdf.getPage(i + 1);
      const viewport = page.getViewport({ scale: 1 });
      const context = canvas.getContext("2d");
      canvas.height = viewport.height;
      canvas.width = viewport.width;
      await page.render({ canvasContext: context, viewport: viewport }).promise;
      var dataURL = canvas.toDataURL();
      images.push(dataURL);
    }
    canvas.remove();
    return images;
    }

    const TIFFtoIMG = async (file) => {
        var im = null;
        let fileBuffer = await file.arrayBuffer();
        try {
            console.log("image load");

            let ifds = UTIF.decode(fileBuffer);
            UTIF.decodeImage(fileBuffer, ifds[0]);
            var rgba = UTIF.toRGBA8(ifds[0]);

            const imageWidth = ifds[0].width;
            const imageHeight = ifds[0].height;

            const cnv = document.createElement("canvas");
            cnv.width = imageWidth;
            cnv.height = imageHeight;

                const ctx = cnv.getContext("2d");
                const imageData = ctx.createImageData(imageWidth, imageHeight);
                for (let i = 0; i < rgba.length; i++) {
                    imageData.data[i] = rgba[i];
                }
            ctx.putImageData(imageData, 0, 0);

            var dataURL = cnv.toDataURL();
            im = dataURL;
            return im;
        }
        catch (ex) {
            console.log(ex);
            return file;
        }

    }

  const [isImage, setIsImage] = useState();
  const onFilesAdded = async (evt) => {
    try {

      const files = evt.target.files;
      console.log(files[0].type);
      let fileBytes = [];


      var reader = new FileReader();
      const img = new Image();
      let document = [];

      if (acceptedImageTypes.includes(files[0].type)) {
        if (files[0].type === 'application/pdf') {
          let fileBytes = await PDFtoIMG(files[0]);

          for (let i = 0; i < fileBytes.length; i++) {
            document.push({
              documentId: doc.documentId,
              file: fileBytes[i].split(',').pop(),
              documentType: doc.code,
              referenceNumber: refNo,
              fileExtension: 'jpg', //files[0].name.split('.').pop(),
              customerID: userInfo.customerId,
              orderNumber: i + 1,
            });
          }
          //if (files[0].type !== 'image/jpeg' && files[0].type !== 'application/pdf') {
          //    notificationContext.setNotification(
          //        'Upload file in JPEG or PDF format.',
          //        'error'
          //    );
          //} else
          if (files[0].size > 2000000) {
            notificationContext.setNotification(
              'File size exceeds 2MB. Please select another image.',
              'error'
            );
          } else {
            var arrDocument = [];
            for (let i = 0; i < document.length; i++) {
              arrDocument.push(document[i])
              uploadDocument(document[i]);
            }
            setUploadedDoc(arrDocument);
          }
        }
        else if (accImageTypes.includes(files[0].type)) { //
          var im = null;
          setIsImage(true);
          if (files[0].type === 'image/tiff') {
              im = await TIFFtoIMG(files[0]);
          } else {
              im = await toBase64(files[0]);
          }

          fileBytes.push(im);

          for (let i = 0; i < fileBytes.length; i++) {
            document.push({
              documentId: doc.documentId,
              file: fileBytes[i].split(',').pop(),
              documentType: doc.code,
              referenceNumber: refNo,
              fileExtension: files[0].name.split('.').pop(),
              customerID: userInfo.customerId,
              orderNumber: i + 1,
              //img: files[0],
            });
          }

          reader.onload = (e) => {
            if (files[0].size > 2000000) {
              notificationContext.setNotification(
                'Image size exceeds 2MB. Please select another image.',
                'error'
              );
            } else {

              var arrDocu = [];
              for (let i = 0; i < document.length; i++) {
                arrDocu.push(document[i])
                uploadDocument(document[i]);

              }
              setUploadedDoc(arrDocu);
            }
            //};

            //img.src = e.target.result;
          };
          reader.readAsDataURL(files[0]);
        }
        else {
          console.log(files[0].type);
          notificationContext.setNotification(
            'Upload file in Image or PDF format.',
            'error'
          );
        }

      }
      else {
        console.log(files[0].type);
        notificationContext.setNotification(
          'Upload file in Image or PDF format.',
          'error'
        );
      }

    } catch (error) { }
  };

  const onFileAdd = async (evt) => {
    try {
      let doctypearr = uploadedDocuments.filter(docu => docu.documentType === doc.code);

        
      const files = evt.target.files;
      let fileBytes = [];

      var reader = new FileReader();
        let document = [];
        if (accImageTypes.includes(files[0].type)) {
            var im = null;
            setIsImage(true);

            if (files[0].type === 'image/tiff') {
                im = await TIFFtoIMG(files[0]);
            } else {
                im = await toBase64(files[0]);
            }
            fileBytes.push(im);

            for (let i = 0; i < fileBytes.length; i++) {
                document.push({
                    documentId: doc.documentId,
                    file: fileBytes[i].split(',').pop(),
                    documentType: doc.code,
                    referenceNumber: refNo,
                    fileExtension: files[0].name.split('.').pop(),
                    customerID: userInfo.customerId,
                    orderNumber: doctypearr.length + 1,
                });
            }

            reader.onload = (e) => {
                //img.onload = () => {
                //if (!accImageTypes.includes(files[0].type)) {
                //    notificationContext.setNotification(
                //        'Upload clear image file in JPEG, TIFF, BMP, GIF, and PNG  format.',
                //        'error'
                //    );
                //} else
                    if (files[0].size > 2000000) {
                    notificationContext.setNotification(
                        'Image size exceeds 2MB. Please select another image.',
                        'error'
                    );
                } else {

                    for (let i = 0; i < document.length; i++) {
                        doctypearr.push(document[i])
                        uploadDocument(document[i]);

                    }
                    setUploadedDoc(doctypearr);
                }
            };
            reader.readAsDataURL(files[0]);


        }
        else {
            console.log(files[0].type);

            notificationContext.setNotification(
                'Upload clear image file in JPEG, TIFF, BMP, GIF, and PNG  format.',
                'error'
            );
        }
        
    } catch (error) { }
  };

  const ColorButton = withStyles((theme) => ({
    root: {
      color: theme.palette.getContrastText('#0054a4'),
      backgroundColor: '#0054a4',
      '&:hover': {
        backgroundColor: '#0054a4',
      },
    },
  }))(Button);

  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };



  const DisplayImage = () => (
    <Fragment>
      {
        uploadedDocument.map((doc, i) => {
          console.log(doc);
          //  if (doc.fileExtension === "tif" || doc.fileExtension === "tiff") {
          //      console.log("tiff");
          //    return (
          //        <img
          //            key={i}
          //            alt='docimg'
          //            //src={`data:image/tiff;base64,${doc.file}`}
          //            src={doc.img}
          //            className={classes.displayImage}
          //        />
          //    )
          //}
          //else {
          return (
            <img
              key={i}
              alt='docimg'
              src={`data:image/jpg;base64,${doc.file}`}
              className={classes.displayImage}
            />
          )

          //}
        })
      }
    </Fragment>

  );
    useEffect(() => {
        UTIF.replaceIMG();
    }, []);

  return (
    <Fragment>
      <Grid container spacing={3}>
        <Grid item xs={7} s={7} sm={7} md={8} l={7} xl={7}>
          <p>
            {doc.description.replace(/\w\S*/g, function (txt) {
              return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
            })}
          </p>
        </Grid>
        {uploadedDocument.length > 0 ? (
          <Grid item xs={3} s={3} sm={3} md={3} l={3} xl={3}>
            <Button
              size='small'
              className={classes.viewFile}
              startIcon={<InsertDriveFileIcon />}
              onClick={handleClickOpen}
            >
              View File
            </Button>
            {isImage &&
              <Fragment>
                <input
                  accept={acceptedImageTypes}
                  className={classes.input}
                  id={'contained-button-file' + doc.code + doc.description}
                  type='file'
                  onChange={onFileAdd}
                />
                <label
                  htmlFor={'contained-button-file' + doc.code + doc.description}
                >
                  <Button size='small' component='span'>
                    <AddIcon /> Add
                          </Button>
                </label>
              </Fragment>
            }
          </Grid>
        ) : (
            <Grid item xs={3} s={3} sm={3} md={3} l={3} xl={3}>
              <input
                accept={acceptedImageTypes}
                className={classes.input}
                id={'contained-button-file' + doc.code + doc.description}
                type='file'
                onChange={onFilesAdded}
              />
              <label
                htmlFor={'contained-button-file' + doc.code + doc.description}
              >
                <ColorButton variant='contained' size='small' component='span'>
                  Upload
              </ColorButton>
              </label>
            </Grid>
          )}
      </Grid>

      <Dialog
        //onload={UTIF.replaceIMG()}
        open={open}
        onClose={handleClose}
        aria-labelledby='alert-dialog-title'
        aria-describedby='alert-dialog-description'
      >
        <DialogTitle id='alert-dialog-title'></DialogTitle>
        <DialogContent>
          <Notification />
          {uploadedDocument.length > 0 ? <DisplayImage /> : <Fragment></Fragment>}
        </DialogContent>

        <DialogActions className={classes.dialogFooter}>
          <Button
            onClick={handleClose}
            color='primary'
            className={classes.deleteButton}
          >
            Close
          </Button>
          <input
            accept={acceptedImageTypes}
            className={classes.input}
            id={'contained-button-file' + doc.code + doc.description}
            type='file'
            onChange={onFilesAdded}
          />
          <label htmlFor={'contained-button-file' + doc.code + doc.description}>
            <ColorButton
              variant='contained'
              size='small'
              component='span'
              style={{ textTransform: 'none' }}
            >
              Reupload
            </ColorButton>
          </label>
        </DialogActions>
      </Dialog>
    </Fragment>
  );
};

export default DocumentItems;
